import React, { createContext, useContext, useState, ReactNode } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

interface TransitionContextType {
  triggerTransition: (to: string, pageName: string) => void
  isTransitioning: boolean
  pageName: string
  onTransitionComplete: () => void
}

const TransitionContext = createContext<TransitionContextType | undefined>(
  undefined
)

export const TransitionProvider = ({ children }: { children: ReactNode }) => {
  const [isTransitioning, setIsTransitioning] = useState(false)
  const [pageName, setPageName] = useState('')
  const navigate = useNavigate()
  const location = useLocation()

  const triggerTransition = (to: string, name: string) => {
    if (location.pathname === to) {
      return
    }

    setIsTransitioning(true)
    setPageName(name)

    setTimeout(() => {
      navigate(to)
    }, 500)
  }

  const onTransitionComplete = () => {
    setIsTransitioning(false)
  }

  return (
    <TransitionContext.Provider
      value={{
        triggerTransition,
        isTransitioning,
        pageName,
        onTransitionComplete,
      }}
    >
      {children}
    </TransitionContext.Provider>
  )
}

export const useTransition = (): TransitionContextType => {
  const context = useContext(TransitionContext)
  if (context === undefined) {
    throw new Error('useTransition must be used within a TransitionProvider')
  }
  return context
}
